import { CommandsRegistry } from '@vscode-alt/monaco-editor/esm/vs/platform/commands/common/commands';
import { Event, Emitter } from '@vscode-alt/monaco-editor/esm/vs/base/common/event';
import { Disposable } from '@vscode-alt/monaco-editor/esm/vs/base/common/lifecycle';
import { timeout } from '@vscode-alt/monaco-editor/esm/vs/base/common/async';

import { injectable, inject } from 'inversify';
import { ICommandService, ICommandEvent } from '@workbench-stack/core';

@injectable()
export class CommandService extends Disposable implements ICommandService {

    public _serviceBrand: undefined;

    private _extensionHostIsReady: boolean = false;
    private _starActivation: Promise<void> | null;

    private readonly _onWillExecuteCommand: Emitter<ICommandEvent> = this._register(new Emitter<ICommandEvent>());
    public readonly onWillExecuteCommand: Event<ICommandEvent> = this._onWillExecuteCommand.event;

    private readonly _onDidExecuteCommand: Emitter<ICommandEvent> = new Emitter<ICommandEvent>();
    public readonly onDidExecuteCommand: Event<ICommandEvent> = this._onDidExecuteCommand.event;

    constructor(
        // @inject(Symbol.for('IInstantiationService'))
        // private _instantiationService: IInstantiationService,
        // @inject(Symbol.for('IExtensionService'))
        // private _extensionService: IExtensionService,
        // @inject(Symbol.for('ILogService'))
        // private readonly _logService: ILogService,
    ) {
        super();
        // this._extensionService.whenInstalledExtensionsRegistered().then(value => this._extensionHostIsReady = value);
        this._starActivation = null;
    }

    private _activateStar(): Promise<void> {
        if (!this._starActivation) {
            // wait for * activation, limited to at most 30s
            this._starActivation = Promise.race<any>([
                // this._extensionService.activateByEvent(`*`),
                timeout(30000),
            ]);
        }
        return this._starActivation;
    }

    public executeCommand<T>(id: string, ...args: any[]): Promise<T> {
        // this._logService.trace('CommandService#executeCommand', id);

        // we always send an activation event, but
        // we don't wait for it when the extension
        // host didn't yet start and the command is already registered

        // const activation: Promise<any> = this._extensionService.activateByEvent(`onCommand:${id}`);
        const commandIsRegistered = !!CommandsRegistry.getCommand(id);

        if (!this._extensionHostIsReady && commandIsRegistered) {
            return this._tryExecuteCommand(id, args);
        } else {
            // let waitFor = activation;
            let waitFor;

            if (!commandIsRegistered) {
                waitFor = Promise.all([
                    // activation,
                    Promise.race<any>([
                        // race * activation against command registration
                        this._activateStar(),
                        Event.toPromise(Event.filter(CommandsRegistry.onDidRegisterCommand, e => e === id)),
                    ]),
                ]);
            }
            return (waitFor as Promise<any>).then(_ => this._tryExecuteCommand(id, args));
        }
    }

    private _tryExecuteCommand(id: string, args: any[]): Promise<any> {
        const command = CommandsRegistry.getCommand(id);
        if (!command) {
            return Promise.reject(new Error(`command '${id}' not found`));
        }
        try {
            this._onWillExecuteCommand.fire({ commandId: id, args } as ICommandEvent);
            // const result = this._instantiationService.invokeFunction(command.handler, ...args);
            this._onDidExecuteCommand.fire({ commandId: id, args } as ICommandEvent);
            // return Promise.resolve(result);
            return;
        } catch (err) {
            return Promise.reject(err);
        }
    }
}
